import { ReviewRating, Starts } from "./styles/ReviewRating.styled";
import { useTranslation } from "react-i18next";

export const GoogleReviewRating = ({ rating }: { rating: number }) => {
  const { t } = useTranslation("product");

  return (
    <>
      <div id="map" />
      {
        <ReviewRating>
          <div>
            <Starts>
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
            </Starts>
          </div>
          <div>
            <p>
              {t("ratingText")} <span>{t("ratingAcross")}</span> {t("ratingReviews")}{" "}
              <span>{t("ratingOnGoogle")}</span> {t("ratingPUCT")}
            </p>
          </div>
        </ReviewRating>
      }
    </>
  );
};

export const PucReviewRating = () => {
  return (
    <>
      {
        <ReviewRating>
          <img src="/images/icon-puc.png" className="puc-icon" alt="" />
          <div>
            <Starts>
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
              <img src="/images/StarFilled.png" alt="" width="20" height="20" />
            </Starts>
            <p>5.0 rating by</p>
            <p>PUC Texas</p>
          </div>
        </ReviewRating>
      }
    </>
  );
};
